export default __webpack_public_path__ + "static/media/img36.bbf54fb6.png";